import React, {Component} from 'react'
import {Button, Spin } from 'antd'
import { ArrowsAltOutlined} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
import {inject, observer} from 'mobx-react'
import {withRouter} from 'react-router-dom'
import history from '../../routes/history'
let flag = null

@inject('reportManagementStore', 'accountStore', 'routerStateModel','auditLogsStore')
@observer
class reportPage extends Component {
  formRef = React.createRef()
  iframeRef = React.createRef()
  state = {
    page: 1, // 当前页
    size: 10, // 每页显示条数
    total: null, // 总条数
    modalVisible: false,
    searchModalVisible: false,
    tableData: [],
    selectLoading: false,
    selectOptions: {},
    generateParams: {},
    dynamicData: [],
    selectedRowKeys: [],
    popTableData: [],
    popTableLoading: false,
    popOpen: false,
    reportType: '查询语句',
    pbiUrl: '',
    reportDescription: '',
    isFullScreen: false,
    canDownload: null,
    searchSort: null,
    sortList: [],
    selectorActiveKey: ['1'],
  }

  // 获取reportId的辅助方法
  getReportId = () => {
    const { match } = this.props;
    
    // 优先从URL参数获取reportId
    if (match && match.params && match.params.id) {
      return match.params.id;
    } else {
      // 向后兼容：从localStorage获取
      const selectedItem = localStorage.getItem('selectedItem');
      if (selectedItem) {
        return selectedItem.split(',')[0];
      }
    }
    return null;
  }

  handleFullScreen = () => {
    const iframeWrap = this.iframeRef.current

    if (document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement) {
      // 如果当前处于全屏状态，则退出全屏
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) { // Firefox
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) { // Chrome, Safari and Opera
        document.webkitExitFullscreen()
      } else if (document.msExitFullscreen) { // IE/Edge
        document.msExitFullscreen()
      }
      this.setState({isFullScreen: false})
    } else {
      // 如果当前不处于全屏状态，则进入全屏
      if (iframeWrap.requestFullscreen) {
        iframeWrap.requestFullscreen()
      } else if (iframeWrap.mozRequestFullScreen) { // Firefox
        iframeWrap.mozRequestFullScreen()
      } else if (iframeWrap.webkitRequestFullscreen) { // Chrome, Safari and Opera
        iframeWrap.webkitRequestFullscreen()
      } else if (iframeWrap.msRequestFullscreen) { // IE/Edge
        iframeWrap.msRequestFullscreen()
      }
      this.setState({isFullScreen: true})
    }
  }
  
  componentDidUpdate(prevProps, prevState, snapshot) {
    const { accountStore, reportManagementStore, routerStateModel } = this.props
    const { currentUrl } = routerStateModel
    const tips = true
    if (flag !== accountStore?.reportFetchFlag) {
      const reportId = this.getReportId()
      flag = accountStore?.reportFetchFlag
      if (reportId && reportId !== 'reportPage' && reportId !== 'pbiReportPage') {
        reportManagementStore.getReportDetail(reportId).then((e) => {
          const {data} = e
          this.setState({
            reportType: data?.type,
            pbiUrl: data?.pbiUrl,
            reportDescription: data?.reportDescription,
            canDownload: data?.canDownload,
            searchSort: null,
            sortList: [],
            selectorActiveKey: ['1']
          })
        })
      }
    }

    if (currentUrl.groupKey !== prevProps.routerStateModel.currentUrl.groupKey) {
      const reportId = this.getReportId()
      reportManagementStore.getReportDetail(reportId).then((e) => {
        const {data} = e
        this.setState({
          reportType: data?.type,
          pbiUrl: data?.pbiUrl,
          reportDescription: data?.reportDescription,
          canDownload: data?.canDownload,
          searchSort: null,
          sortList: [],
          selectorActiveKey: ['1']
        })
      })
    }
  }

  componentDidMount() {
    const {reportManagementStore} = this.props
    const reportId = this.getReportId()
    if (reportId && reportId !== 'reportPage' && reportId !== 'pbiReportPage') {
      reportManagementStore.getReportDetail(reportId).then((e) => {
        const {data} = e
        this.setState({
          reportType: data?.type,
          pbiUrl: data?.pbiUrl,
          reportDescription: data?.reportDescription,
          canDownload: data?.canDownload
        })
      })
    }
  }

  componentWillUnmount() {
    const { match } = this.props;
    
    // 优先从URL参数判断
    if (!match || !match.params || !match.params.id) {
      // 如果没有URL参数，则检查localStorage
      if (!localStorage.getItem('selectedItem')) {
        history.push('/')
      }
    }
  }

  render() {
    const {reportManagementStore} = this.props
    const {isFetching} = reportManagementStore
    const {
      pbiUrl,
      isFullScreen,
    } = this.state
    return (
      <Spin spinning={isFetching}>
            <div className="container" ref={this.iframeRef}>
              <div className={pbiUrl?.includes('https://iedw-bi.ciif-expo.com') ? 'button-task-blue' : 'button-task'}></div>
              <div className={pbiUrl?.includes('https://iedw-bi.ciif-expo.com') ? 'right-task-blue' : 'right-task'}></div>
              <Button icon={<ArrowsAltOutlined/>}
                      className={pbiUrl?.includes('https://iedw-bi.ciif-expo.com') ? 'iframe-fullscreen-button-blue' : 'iframe-fullscreen-button'}
                      onClick={this.handleFullScreen}></Button>
              <iframe className={isFullScreen ? 'iframe-fullscreen-style' : 'iframe-not-fullscreen-style'}
                      src={pbiUrl}></iframe>
            </div>
      </Spin>
    )
  }
}

export default withRouter(withTranslation()(reportPage))
